/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, Col, DatePicker, Form, Input, Row, Switch } from "antd";
import moment from "moment";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import SelectPage from "../../components/select/SelectPage";
import UploadPreview from "./UploadPreview";

const FormBanner = ({ form }, ref) => {
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.file;
  };

  const { getFieldDecorator, getFieldsValue, setFieldsValue } = form;
  const [page, setPage] = useState("");
  const [backupBanners, setBackupBanners] = useState({
    online_banner: null,
    mobile_banner: null,
  });
  const start_date = getFieldsValue().start_date;
  const end_date = getFieldsValue().end_date;
  const getPage = getFieldsValue().page;
  // const currentPageRef = useRef(getFieldsValue().page);

  const currentPageRef = useRef();

  const handlePageChange = (newPage) => {
    const currentPage = currentPageRef.current;
    const currentValues = getFieldsValue();
    if (newPage !== currentPage) {
      // เก็บค่าปัจจุบันก่อนเปลี่ยนลง backup
      setBackupBanners({
        online_banner: currentValues.online_banner,
        mobile_banner: currentValues.mobile_banner,
      });

      // รีเซ็ตค่า online_banner, mobile_banner ในฟอร์ม
      setFieldsValue({
        online_banner: undefined,
        mobile_banner: undefined,
        page: newPage,
      });

      setPage(newPage);
    } else {
      // ถ้าเลือก page เดิม (กดซ้ำ หรือ reset)
      // กู้คืนค่า online_banner, mobile_banner จาก backup
      setFieldsValue({
        online_banner: backupBanners.online_banner,
        mobile_banner: backupBanners.mobile_banner,
        page: newPage,
      });
    }
  };

  useEffect(() => {
    if (getPage) {
      setPage(getPage);
    }
  }, [getPage]);

  useEffect(() => {
    setTimeout(() => {
      const initialPage = form.getFieldValue("page") || "";
      currentPageRef.current = initialPage;
    }, 500);
  }, []);

  return (
    <Form colon={false}>
      <Row gutter={{ xs: 16, md: 32 }}>
        {page !== "web-menu" ? (
          <Col md={12}>
            <Form.Item label="Desktop: 1440 x 337 px | Size ไม่เกิน 1 MB | ประเภทไฟล์ที่รองรับ .jpg, .png, .WebP">
              {getFieldDecorator("online_banner", {
                valuePropName: "file",
                getValueFromEvent: normFile,
              })(<UploadPreview fix_width={1440} fix_height={337} />)}
            </Form.Item>
            <Form.Item label="Tablet/Mobile: 1440 x 768 px | Size ไม่เกิน 1 MB | ประเภทไฟล์ที่รองรับ .jpg, .png, .WebP">
              {getFieldDecorator("mobile_banner", {
                valuePropName: "file",
                getValueFromEvent: normFile,
              })(<UploadPreview fix_width={1440} fix_height={768} />)}
            </Form.Item>
          </Col>
        ) : (
          <Col md={12}>
            <Form.Item label="Desktop: 2309 x 457 px | Size ไม่เกิน 1 MB | ประเภทไฟล์ที่รองรับ .jpg, .png, .WebP">
              {getFieldDecorator("online_banner", {
                valuePropName: "file",
                getValueFromEvent: normFile,
              })(<UploadPreview fix_width={2309} fix_height={457} />)}
            </Form.Item>
            <Form.Item label="Tablet/Mobile: 1200 x 401 px | Size ไม่เกิน 1 MB | ประเภทไฟล์ที่รองรับ .jpg, .png, .WebP">
              {getFieldDecorator("mobile_banner", {
                valuePropName: "file",
                getValueFromEvent: normFile,
              })(<UploadPreview fix_width={1200} fix_height={401} />)}
            </Form.Item>
          </Col>
        )}
        <Col md={12}>
          <Form.Item label="หน้าจอ" style={{ margin: 0 }}>
            {getFieldDecorator("page", {
              initialValue: "",
              rules: [
                { required: true, message: "กรุณาเลือกหน้าจอแสดงแบนเนอร์" },
              ],
            })(
              <SelectPage
                withAll
                allText="เลือกหน้าจอ"
                onChange={handlePageChange}
              />
            )}
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <label
                style={{
                  whiteSpace: "nowrap",
                  marginRight: 8,
                  marginBottom: 0,
                }}
              >
                ลิงก์สำหรับ Web:
              </label>
              {getFieldDecorator("web_link", {
                initialValue: "",
                rules: [{ required: false }],
              })(
                <Input placeholder="วาง Url ที่นี่" style={{ width: "100%" }} />
              )}
            </div>
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <label
                style={{
                  whiteSpace: "nowrap",
                  marginRight: 8,
                  marginBottom: 0,
                }}
              >
                ลิงก์สำหรับ App:
              </label>
              {getFieldDecorator("app_link", {
                initialValue: "",
                rules: [{ required: false }],
              })(
                <Input placeholder="วาง Url ที่นี่" style={{ width: "100%" }} />
              )}
            </div>
          </Form.Item>
          <Form.Item label="แสดงผล">
            {getFieldDecorator("show", {
              initialValue: [],
            })(
              <Checkbox.Group>
                <Checkbox value="online">Desktop</Checkbox>
                <Checkbox value="mobile">Tablet/Mobile</Checkbox>
                {/* {page !== "web-menu" && (
                  <Checkbox value="mobile">Mobile</Checkbox>
                )} */}
              </Checkbox.Group>
            )}
          </Form.Item>
          <Form.Item label="เริ่มต้น">
            {getFieldDecorator("start_date", {
              initialValue: moment().startOf("month"),
            })(
              <DatePicker
                showTime
                placeholder="เริ่มต้น"
                format="DD/MM/YYYY HH:mm:ss"
                disabledDate={(current) => end_date && current > end_date}
              />
            )}
          </Form.Item>
          <Form.Item label="สิ้นสุด">
            {getFieldDecorator("end_date", {
              initialValue: moment().endOf("month"),
            })(
              <DatePicker
                showTime
                placeholder="สิ้นสุด"
                format="DD/MM/YYYY HH:mm:ss"
                disabledDate={(current) => start_date && current < start_date}
              />
            )}
          </Form.Item>
          <Form.Item label="ใช้งาน">
            {getFieldDecorator("status", {
              initialValue: true,
              valuePropName: "checked",
            })(<Switch />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Form.create("banner")(forwardRef(FormBanner));
